/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Qr_No_PhoneInputs */

const vi_grower_qr_no_phone = /** @type {(inputs: Grower_Qr_No_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ này chưa có số điện thoại.`)
};

/**

* @param {Grower_Qr_No_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_qr_no_phone = /** @type {((inputs?: Grower_Qr_No_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Qr_No_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_qr_no_phone(inputs)
});